import React, { useEffect, useState } from 'react';
import { BowMark } from './BowMark';
import { BRAND, NAV_LINKS, OFFER_ANCHOR } from '../data/collection';

/** Sticky top bar: wordmark, section links and a quiet link to the price. */
export function NavBar() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className={`sticky top-0 z-30 hidden w-full bg-ivory/95 md:block backdrop-blur transition-[box-shadow] duration-200 ease-out ${scrolled ? 'shadow-[0_1px_0_0_#E7DED3]' : ''}`} data-id="element-144" data-mp="1vyc8tmbcwigg">
      <nav aria-label="Principal" className="mx-auto flex h-16 max-w-6xl items-center justify-between gap-4 px-5 sm:px-8" data-id="element-145" data-mp="25tnsmj1mgfv2">
        <a href="#inicio" className="flex min-h-[48px] items-center gap-2 rounded-md focus:outline-none focus-visible:ring-4 focus-visible:ring-coral/40" data-id="element-146" data-mp="3ha48gdh38yig">
          <BowMark className="h-6 w-9 shrink-0" data-id="element-147" data-mp="1byljj89d8zc5" />
          <span className="whitespace-nowrap font-serif text-[1.25rem] font-semibold italic text-graphite sm:text-[1.35rem]" data-id="element-148" data-mp="1guam7kgomwco">
            {BRAND.name}
          </span>
        </a>

        <ul className="hidden items-center gap-1 md:flex" data-id="element-149" data-mp="1pwjx4bfv4rql">
          {NAV_LINKS.map(link => <li key={link.href} data-id="element-150" data-mp="t6awmnv3xbzo">
              <a href={link.href} className="flex min-h-[48px] items-center rounded-full px-3.5 text-[0.95rem] font-semibold text-graphite-soft transition-colors duration-150 ease-out hover:text-coral-ink focus:outline-none focus-visible:ring-4 focus-visible:ring-coral/40" data-id="element-151" data-mp="t72eywzp1d80">
                {link.label}
              </a>
            </li>)}
        </ul>

        <a href={OFFER_ANCHOR} className="flex min-h-[48px] shrink-0 items-center whitespace-nowrap rounded-full px-4 text-[0.95rem] font-bold text-coral-ink ring-1 ring-inset ring-coral/40 transition-[background-color] duration-150 ease-out hover:bg-blush focus:outline-none focus-visible:ring-4 focus-visible:ring-coral/40" data-id="element-152" data-mp="9h8smyfqzqb6">
          Ver precio
        </a>
      </nav>
    </header>;
}